import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ErrorBoundary from './components/ErrorBoundary';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import DashboardSupervision from './components/DashboardSupervision';
import Relevos from './components/Relevos';
import RegistrarNovedad from './components/RegistrarNovedad';
import RegistrarVisitante from './components/RegistrarVisitante';
import SalidaVisitante from './components/SalidaVisitante';
import RegistrarVehiculo from './components/RegistrarVehiculo';
import SalidaVehiculo from './components/SalidaVehiculo';
import SalidaVehiculoInstitucional from './components/SalidaVehiculoInstitucional';
import RetornoVehiculoInstitucional from './components/RetornoVehiculoInstitucional';
import ConsultasEventos from './pages/ConsultasEventos';
import ArmamentoSupervision from './components/ArmamentoSupervision';
import RegistrarAsistencia from './components/RegistrarAsistencia';
import VisitasRealizadas from './components/VisitasRealizadas';
import ControlRelevos from './components/ControlRelevos';
import CertificadoMultaFaltaPunto from './components/CertificadoMultaFaltaPunto';
import Sanciones from './components/Sanciones';
import SupervisionRutaProgramada from './components/SupervisionRutaProgramada';
import MisRutasSupervision from './components/MisRutasSupervision';
import GestionarCatalogo from './components/GestionarCatalogo';
import BitacoraPersonalizada from './components/BitacoraPersonalizada';
import Tango3 from './components/Tango3';
import AlfaTango1 from './components/AlfaTango1';
import RondaOffline from './components/RondaOffline';
import AlertaVigilancia from './components/AlertaVigilancia';
import ReenvioAlertaVigilancia from './components/ReenvioAlertaVigilancia';
import environment from './config/environment';

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <Router>
          <div className="min-h-screen bg-gray-50">
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/dashboard" element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              } />
              <Route path="/dashboard-supervision" element={
                <ProtectedRoute>
                  <DashboardSupervision />
                </ProtectedRoute>
              } />
              <Route path="/relevos" element={
                <ProtectedRoute>
                  <Relevos />
                </ProtectedRoute>
              } />
              <Route path="/novedades/registrar" element={
                <ProtectedRoute>
                  <RegistrarNovedad />
                </ProtectedRoute>
              } />
              <Route path="/visitantes/registrar" element={
                <ProtectedRoute>
                  <RegistrarVisitante />
                </ProtectedRoute>
              } />
              <Route path="/visitantes/salida" element={
                <ProtectedRoute>
                  <SalidaVisitante />
                </ProtectedRoute>
              } />
              <Route path="/vehiculos/registrar" element={
                <ProtectedRoute>
                  <RegistrarVehiculo />
                </ProtectedRoute>
              } />
              <Route path="/vehiculos/salida" element={
                <ProtectedRoute>
                  <SalidaVehiculo />
                </ProtectedRoute>
              } />
              <Route path="/vehiculos-institucionales/salida" element={
                <ProtectedRoute>
                  <SalidaVehiculoInstitucional />
                </ProtectedRoute>
              } />
              <Route path="/vehiculos-institucionales/retorno" element={
                <ProtectedRoute>
                  <RetornoVehiculoInstitucional />
                </ProtectedRoute>
              } />
              <Route path="/consultas/eventos" element={
                <ProtectedRoute>
                  <ConsultasEventos />
                </ProtectedRoute>
              } />
              <Route path="/supervision/registrar-asistencia" element={
                <ProtectedRoute>
                  <RegistrarAsistencia />
                </ProtectedRoute>
              } />
              <Route path="/supervision/armamento" element={
                <ProtectedRoute>
                  <ArmamentoSupervision />
                </ProtectedRoute>
              } />
              <Route path="/supervision/visitas-realizadas" element={
                <ProtectedRoute>
                  <VisitasRealizadas />
                </ProtectedRoute>
              } />
              <Route path="/supervision/control-relevos" element={
                <ProtectedRoute>
                  <ControlRelevos />
                </ProtectedRoute>
              } />
              <Route path="/supervision/certificado-multa-falta-punto" element={
                <ProtectedRoute>
                  <CertificadoMultaFaltaPunto />
                </ProtectedRoute>
              } />
              <Route path="/supervision/sanciones" element={
                <ProtectedRoute>
                  <Sanciones />
                </ProtectedRoute>
              } />
              <Route path="/supervision/ruta-programada" element={
                <ProtectedRoute>
                  <SupervisionRutaProgramada />
                </ProtectedRoute>
              } />
              <Route path="/supervision/mis-rutas" element={
                <ProtectedRoute>
                  <MisRutasSupervision />
                </ProtectedRoute>
              } />
              <Route path="/utilidades/gestionar-catalogo" element={
                <ProtectedRoute>
                  <GestionarCatalogo />
                </ProtectedRoute>
              } />
              <Route path="/bitacora-personalizada" element={
                <ProtectedRoute>
                  <BitacoraPersonalizada />
                </ProtectedRoute>
              } />
              {/* Tango3: flujo guía/bodega; distinto de Alfa Tango 1 y de un futuro Alfa Tango 2. */}
              <Route path="/tango3" element={
                <ProtectedRoute>
                  <Tango3 />
                </ProtectedRoute>
              } />
              {/* Alfa Tango 1: Visita + Funcionarios (misma pantalla que bitácora con código alfa_tango_1). */}
              <Route path="/alfa-tango-1" element={
                <ProtectedRoute>
                  <AlfaTango1 />
                </ProtectedRoute>
              } />
              <Route path="/ronda" element={
                <ProtectedRoute>
                  <RondaOffline />
                </ProtectedRoute>
              } />
              <Route path="/alerta-vigilancia" element={
                <ProtectedRoute>
                  <AlertaVigilancia />
                </ProtectedRoute>
              } />
              {!environment.isProduction && (
              <Route path="/supervision/reenvio-alerta" element={
                <ProtectedRoute>
                  <ReenvioAlertaVigilancia />
                </ProtectedRoute>
              } />
              )}
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Routes>
          </div>
        </Router>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App; 